export default "__VITE_ASSET__C8JgFtg6__"